import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { InicioComponent } from '../pages/inicio/inicio.component';
import { PedidoComponent } from '../pages/pedido/pedido.component';
import { ArticulosComponent } from '../pages/articulos/articulos.component';
import { RegistroClienteComponent } from '../pages/registro-cliente/registro-cliente.component';
import { CarritoComponent } from '../pages/carrito/carrito.component';
import { LoginClienteComponent } from '../pages/login-cliente/login-cliente.component';
import { GestionPedidoComponent } from '../pages/gestion-pedido/gestion-pedido.component';
import { GestionPedidoDetalleComponent } from '../pages/gestion-pedido-detalle/gestion-pedido-detalle.component';
import { ProductoComponent } from '../pages/producto/producto.component';
import { CategoriaComponent } from '../pages/categoria/categoria.component';
import { RedirectComponent } from '../pages/redirect/redirect.component';
import { PedidoClienteComponent } from '../pages/pedido-cliente/pedido-cliente.component';
import { CambioComponent } from '../pages/cambio/cambio.component';
import { PrivacityComponent } from '../pages/privacity/privacity.component';
import { CodigoDescuentoComponent } from '../pages/codigo-descuento/codigo-descuento.component';
const routes:Routes=[
  {path:'login', component: LoginComponent },
  {path:'register', component:RegisterComponent},
  {path:'inicio', component:InicioComponent},
  {path:'articulos/:idCategoria', component:ArticulosComponent},
  {path:'pedido/:idProducto/:modoPedido/:idPedido/:idProductoAnterior/:precioAnterior/:indiceDetallePedido', component:PedidoComponent},
  {path:'redirect/:id', component:RedirectComponent},
  {path:'registro-cliente/:idTipo', component:RegistroClienteComponent},
  {path:'carrito', component:CarritoComponent},
  {path:'login-cliente/:idTipo', component:LoginClienteComponent},
  {path:'gestion-pedido', component:GestionPedidoComponent},
  {path:'gestion-pedido-detalle/:idPedido', component:GestionPedidoDetalleComponent},
  {path:'producto', component:ProductoComponent},
  {path:'categoria', component:CategoriaComponent},
  {path:'cambio', component:CambioComponent},
  {path:'pedido-cliente', component:PedidoClienteComponent},
  {path:'privacity', component:PrivacityComponent},
  {path:'codigo-descuento', component:CodigoDescuentoComponent}
]


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports:[RouterModule]
})
export class AuthRoutingModule { }
